import { render } from "./ExamForm.vue?vue&type=template&id=86273112&scoped=true"
import script from "./ExamForm.vue?vue&type=script&lang=js"
export * from "./ExamForm.vue?vue&type=script&lang=js"

import "./ExamForm.vue?vue&type=style&index=0&id=86273112&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86273112"]])

export default __exports__